module.exports = __webpack_public_path__ + "img/specialImg01.03964407.jpg";